import { Box, Text, styled } from '@ltvco/refresh-lib/theme';
import { PictureAsPdf } from '@mui/icons-material';

const StyledPdfPreviewBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'clickable',
})<{ size: number; clickable: boolean }>(({ theme, size, clickable }) => ({
  width: size,
  height: size,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 8,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.grey[100],
  ...(clickable && {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  }),
}));

export interface PdfPreviewBoxProps {
  size?: number;
  iconSize?: number;
  onClick?: () => void;
}

export const PdfPreviewBox = ({
  size = 100,
  iconSize = 40,
  onClick,
}: PdfPreviewBoxProps) => (
  <StyledPdfPreviewBox
    size={size}
    clickable={Boolean(onClick)}
    onClick={onClick}
  >
    <PictureAsPdf
      sx={{ fontSize: iconSize, color: 'error.main' }}
      aria-hidden
    />
    <Text
      sx={{
        fontSize: 10,
        color: 'text.secondary',
        textAlign: 'center',
        mt: 0.5,
      }}
    >
      PDF
    </Text>
  </StyledPdfPreviewBox>
);
